import React, { ReactNode } from "react";
import styled from "@emotion/styled";
import { Card, H3, Text } from "@atoms";

// == Types ================================================================

interface IProps {
  title: string;
  children: ReactNode;
  altLink?: string;
  altOnClick?: () => void;
}

// == Constants ============================================================
ContentBlock.defaultProps = {
  altLink: null,
  altOnClick: null,
};

// == Component ============================================================

export default function ContentBlock({ title, children, altLink, altOnClick }: IProps) {
  return (
    <Card p={3}>
      <H3 mb={3}>
        {title}
        {altLink && (
          <EText as="p" display="inline-block" fontSize="1" ml={2} onClick={altOnClick}>
            {altLink}
          </EText>
        )}
      </H3>
      {children}
    </Card>
  );
}

// == Styles ===============================================================

const EText = styled(Text)`
  color: ${({ theme }) => theme.colors.primary};
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;
